import Products from '../components/setup/Products.vue';
import CommissionMatches from '../components/setup/CommissionMatches.vue';

export default [
	{
		path: '/products',
		name: 'Products',
		component: Products,
		meta: {
			requiresAuth: true,
			permissions: {
				Carriers: ["Edit Carriers"]
			}
		}
	},
	{
		path: '/commission-matches',
		name: 'CommissionMatches',
		component: CommissionMatches,
		meta: {
			requiresAuth: true,
			permissions: {
				Carriers: ["Edit Carriers"]
			}
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/SetupRoutes.js